import { useState } from 'react';
import { Info } from 'lucide-react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

let nextId = 0;

/**
 * Small icon that shows `content` in a tooltip on hover/focus. Defaults to an
 * "i" info icon; pass any lucide-react component as `icon` to change it.
 * Wraps react-tooltip so callers don't have to wire up ids/anchors.
 */
export default function Tooltip({ content, icon: Icon = Info }) {
	const [id] = useState(() => `tooltip-${nextId++}`);

	if (!content) return null;

	return (
		<>
			<Icon
				className='size-3.5 text-gray-400 hover:text-gray-600 cursor-help shrink-0'
				data-tooltip-id={id}
				data-tooltip-content={content}
				aria-label={content}
			/>
			<ReactTooltip id={id} className='max-w-xs z-50' />
		</>
	);
}
